import {noop} from 'lodash';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../core/src/helpers/internationalization/react';
import {CheckBox} from '../../booleanInputs/checkBox';
import {DropdownItemRightIcon} from './dropdownItemRightIcon';

/*
 * Props.
 */

interface DropdownItemCheckmarkProps {
  label?: ReactNode;
  isChecked: boolean;
  isCheckbox?: boolean;
  isHovered?: boolean;
  onCheckboxChange?: (isChecked: boolean) => void;
}

/*
 * Style.
 */

const StyledCheckBoxWrapper = styled.div`
  grid-area: right-icon;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
`;

/*
 * Component.
 */

export const DropdownItemCheckmark: FC<DropdownItemCheckmarkProps> = ({
  isChecked,
  label,
  isCheckbox,
  isHovered,
  onCheckboxChange,
}) => {
  if (isCheckbox) {
    // Only show checkbox when selected or hovered
    if (!isChecked && !isHovered) {
      return null;
    }

    return (
      <StyledCheckBoxWrapper>
        <CheckBox
          isChecked={isChecked}
          onChange={onCheckboxChange ?? noop}
          shouldStopPropagation={Boolean(onCheckboxChange)}
        />
      </StyledCheckBoxWrapper>
    );
  }

  if (!isChecked) {
    return null;
  }

  return (
    <DropdownItemRightIcon
      label={label || <Trans id="dropdownitemcheckmark-label">Checked</Trans>}
      rightIconName="check/outlined/16"
      isChecked
    />
  );
};
